// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__HRbp6","hoverable":"styles_hoverable__USrdH"};